
import { ModalProps } from '../models';
import {ReactComponent as DeleteIcon} from '../../../images/nde-icon-delete.svg';
import './SystemRequirementsModal.scss';
import ReactModal from 'react-modal';
import { useSelector } from 'react-redux';
import { selectControls } from '../../../redux/controls';


export const SystemRequirementsModal = ({open, onClose}: ModalProps): JSX.Element => {
  const controls = useSelector(selectControls);

  return (
    <>
      {
        open &&
        <ReactModal
          isOpen={open}
          className="nqt-modal nqt-sys-req-modal"
          overlayClassName="nqt-modal-overlay"
          shouldFocusAfterRender={true}
          shouldReturnFocusAfterClose={true}
          contentLabel={controls?.FooterRequirementsPUTitle?.controlText}
        >
          <div className='nqt-modal--container'>
            <div className="nqt-modal--header-group">
              <header className='nqt-modal--title'>{controls?.FooterRequirementsPUTitle?.controlText}</header>
              <button className='nqt-modal--close-button'
                ref={(el) => el?.focus()}
                onClick={() => onClose(false)}>
                <DeleteIcon/>
                <span className="visually-hidden">{controls?.ModalClose?.controlText}</span>
              </button>
            </div>
            <div className="nqt-modal--border">
              <section className="nqt-modal--content">
                <span className="title_sm">System Requirements:</span>
                <div className="requirements">
                  <ul className="system_show">
                    <li>Minimum recommended screen resolution is 1024x768</li>
                    <li>Internet Explorer 11 not supported</li>
                    <li>Microsoft Edge</li>
                    <li>Firefox</li>
                    <li>Google Chrome</li>
                    <li>Safari</li>
                    <li>Enable JavaScript and pop-ups in your browser</li>
                  </ul>
                </div>
              </section>
            </div>
          </div>
        </ReactModal>
      }
    </>
  );
};

export default SystemRequirementsModal;